import React from 'react';
import {Button, Table} from 'react-unity';
import {useNavigate} from 'react-router-dom';
import styled from 'styled-components';
import VirtualMachineRequest from '../../models/entities/VirtualMachineRequest';
import './VirtualMachineRequestTableRow.css';
import WorkflowStateBadge from '../common/WorkflowStateBadge';
import moment from 'moment';

interface VirtualMachineRequestTableRowProps {
	request: VirtualMachineRequest;
	subsId: number;
}

const StyledButton = styled(Button)`
	width: 120px;
	height: 34px;
`;

const VirtualMachineRequestTableRow = ({
	request,
	subsId
}: VirtualMachineRequestTableRowProps) => {

	const navigate = useNavigate();

	const handleSeeDetails = () => {
		navigate(`/subscriptions/${subsId}/virtualMachineRequest/${request.id}`);
	};

	return (
		<Table.Body.Row key={request.id}>
			<Table.Body.Cell>{request.id}</Table.Body.Cell>
			<Table.Body.Cell>{request.requesterUser.displayName}</Table.Body.Cell>
			<Table.Body.Cell style={{position: 'relative'}}>
				<WorkflowStateBadge
					workflowState={request.workflowInstance.currentWorkflowInstanceState.workflowState}
					fullWidth
				/>
			</Table.Body.Cell>
			<Table.Body.Cell>{request.environment}</Table.Body.Cell>
			<Table.Body.Cell>{request.os}</Table.Body.Cell>
			<Table.Body.Cell>{request.patchMode}</Table.Body.Cell>
			<Table.Body.Cell>{moment(request.workflowInstance.currentWorkflowInstanceState.performedOnDate).format('MM/DD/YYYY')}</Table.Body.Cell>
			<Table.Body.Cell>
				<Button.Group>
					<StyledButton onClick={handleSeeDetails} variant="primary">
						See Details
					</StyledButton>
				</Button.Group>
			</Table.Body.Cell>
		</Table.Body.Row>
	);
};

export default VirtualMachineRequestTableRow;
